import { useState } from 'react'
import styled from 'styled-components'

import './style.css'
import { ProgressStep } from './progressStep'

const ProgressFlowIndicator = styled.div`
position: relative;
margin-top:20px;
margin-left:11%;
margin-bottom: 36px;
@media (max-width: 468px) {
  width: 110%;
  margin-left: 0;
}
&:before {
  content: '';
  position: absolute;
  left: 15%;
  right:25%;
  top: 16px;
  height: 2px;
  background-color:  #cccccc;
  box-shadow: fade( #cccccc, 50%);
  @media (max-width: 468px) {
    left: 14%;
    right: 24%;
  }
}
`
const ProcessFlowSteps = styled.div`
display: table;
width: 90%;
`

type ProcessFlowProps = {
  active: string
}


const ProcessFlow = (props: ProcessFlowProps) => {
  const [state] = useState({
    steps: [
      {
        name: 'Find Claim',
        class: props.active === 'claims' ? 'active' : 'completed',
        ariaLabel: props.active === 'claims' ? 'Current' : 'Completed'
      },
      {
        name: 'Contact Details',
        class: props.active === 'identity' ? 'active' : props.active === 'claims' ?
          'upcoming' : 'completed',
        ariaLabel: props.active === 'identity' ? 'Current' : props.active === 'claims' ?
          'Upcoming' : 'Completed'
      },
      {
        name: 'Uploads',
        class: props.active === 'upload' ? 'active' : 'upcoming',
        ariaLabel: props.active === 'upload' ? 'Current' : 'Upcoming'
      }
    ]

  })

  return (
    <ProgressFlowIndicator id="progressFlowIndicator">
      <ProcessFlowSteps>{
        state.steps.map(function (item, i) {
          return (
            <ProgressStep
              key={i}
              label={item.name}
              cssClass={item.class}
              ariaLabel={item.ariaLabel}
            />
          )
        })
      }
      </ProcessFlowSteps>
    </ProgressFlowIndicator>
  )
}

export { ProcessFlow }
